import axios, { AxiosRequestHeaders } from "axios";
import { LocalStorage } from "./localStorage";
import { app_placeholder } from "../env.placeholders";

export const Https = axios.create({
  baseURL: app_placeholder.VITE_APP_API_BASE_URL,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${LocalStorage.token.get()}`
  },
});

export const HttpsImport = axios.create({
  baseURL: app_placeholder.VITE_APP_API_BASE_URL,
  headers: {
    Accept: '*/*',
    'Content-Type': 'text/plain',
    Authorization: `Bearer ${LocalStorage.token.get()}`
  },
});

export const HttpsZip = axios.create({
  baseURL: app_placeholder.VITE_APP_API_BASE_URL,
  responseType: "arraybuffer",
  headers: {
    Accept: "application/json",
  },
});

export const HttpArcgis = axios.create({
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${LocalStorage.token.get()}`
  },
});

HttpArcgis.interceptors.request.use(
  (config) => {
    config.headers = {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LocalStorage.token.get()}`
    }as AxiosRequestHeaders;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Https.interceptors.request.use(
  (config) => {
    config.headers = {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LocalStorage.token.get()}`
    }as AxiosRequestHeaders;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

HttpsZip.interceptors.request.use(
  (config) => {
    config.headers = {
      Authorization: `Bearer ${LocalStorage.token.get()}`,
      Accept: "application/json"
    }as AxiosRequestHeaders;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
